export enum Periods {
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}
